import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FailedToLinkContent from 'Organisms/FailedToLinkContent/FailedToLinkContent';
import { DialogActions } from 'Views/Page/Content/Modal/Components';
import { dataAttrs } from 'Helpers/Testing';
import { FDPrimaryActionButton, FDSecondaryActionButton, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';

const styles = () => ({
  root: {},
});

const FailedToLinkTemplate = () => {
  const {
    modalResource,
    clearModalCollection,
    loadModalCollectionByLink,
  } = useModalContext();

  return (
    <>
      <FailedToLinkContent resource={modalResource} />
      <DialogActions>
        <FDStack direction={'row'} spacing={1}>
          {modalResource.withRelationship(fr.relationships.addManually.name,
            (rel) => (
              <FDSecondaryActionButton
                label={'Add manually'}
                onClick={() => {
                  loadModalCollectionByLink(rel.link('related').url());
                }}
              />
            ),
            () => null)}
          <FDPrimaryActionButton
            onClick={clearModalCollection}
            label="Close"
            {...dataAttrs('close-modal-btn')}
          />
        </FDStack>
      </DialogActions>
    </>
  );
};

FailedToLinkTemplate.defaultProps = {};

FailedToLinkTemplate.propTypes = {};

export default withStyles(styles)(FailedToLinkTemplate);
